
/**
 * 상세 에러 정보 (선택적)
 * @nullable
 */
export type ListConversations401Details = { [key: string]: unknown } | null;
